import React from 'react'

export default p => (
  <div className="p16">
    <h1>Links</h1>
    <div className="ui divider"></div>

    <li>
      <a href="http://ttcan.ca/en/home/rating.aspx" target="_new">
        Canadian Ranking
      </a>
    </li>
    <br />

    <li>
      <a href="https://www.ittf.com/rankings/" target="_new">
        ITTF World Ranking
      </a>
    </li>
    <br />

    <li>
      <a href="http://cttsl.sports.cn/" target="_new">
        Offical Website for China Table Tennis Super League
      </a>
    </li>
    <br />

    <li>
      <a href="https://butterflyonline.com/" target="_new">
        Butterfly
      </a>
    </li>
    <br />

    <li>
      <a href="http://www.joolausa.com/" target="_new">
        Joola
      </a>
    </li>
  </div>
)
